import { QueryCache, MutationCache, QueryClient } from '@tanstack/react-query';
import { dispatchToast } from './toast';

// Create a client
export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: error => {
      dispatchToast(error.message || 'An error occurred fetching data', 'error');
    },
  }),
  mutationCache: new MutationCache({
    onError: error => {
      dispatchToast(error.message || 'An error occurred performing action', 'error');
    },
  }),
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: (failureCount, error) => {
        // Don't retry on 4xx errors
        if (error instanceof Error && 'status' in error) {
          const status = (error as { status: number }).status;
          if (status >= 400 && status < 500) {
            return false;
          }
        }
        return failureCount < 3;
      },
    },
    mutations: {
      retry: false,
    },
  },
});
